// extracted by mini-css-extract-plugin
export default {"info-icon":"LatestMediaGallery_info-icon__eobyC","top-upload-btn":"LatestMediaGallery_top-upload-btn__yggC4","content-divider":"LatestMediaGallery_content-divider__txGP6"};